
(function(){
  if(window.supabase&&window.supabase.createClient)return;

  function createClient(base,key,options){
    var storageKey='rc-auctions-session-v1';
    var listeners=[];

    function getStored(){
      try{
        var raw=localStorage.getItem(storageKey);
        return raw?JSON.parse(raw):null;
      }catch(e){return null}
    }
    function store(session){
      try{
        if(session)localStorage.setItem(storageKey,JSON.stringify(session));
        else localStorage.removeItem(storageKey);
      }catch(e){}
    }
    function notify(event,session){
      listeners.slice().forEach(function(fn){try{fn(event,session)}catch(e){}});
    }
    function apiHeaders(json){
      var h={apikey:key};
      var s=getStored();
      if(s&&s.access_token)h.Authorization='Bearer '+s.access_token;
      if(json)h['Content-Type']='application/json';
      return h;
    }
    async function parseResponse(res){
      var text=await res.text();
      var body=null;
      if(text){
        try{body=JSON.parse(text)}catch(e){body=text}
      }
      if(!res.ok){
        var msg=(body&&body.msg)||(body&&body.message)||(body&&body.error_description)||(body&&body.error)||('HTTP '+res.status);
        return {data:null,error:{message:String(msg),status:res.status,details:body}};
      }
      return {data:body,error:null};
    }
    async function refreshIfNeeded(){
      var s=getStored();
      if(!s||!s.refresh_token)return s;
      var exp=Number(s.expires_at||0);
      if(exp&&Date.now()/1000<exp-45)return s;
      try{
        var res=await fetch(base+'/auth/v1/token?grant_type=refresh_token',{
          method:'POST',
          headers:{apikey:key,'Content-Type':'application/json'},
          body:JSON.stringify({refresh_token:s.refresh_token})
        });
        var p=await parseResponse(res);
        if(p.error){store(null);notify('SIGNED_OUT',null);return null}
        var n=p.data||{};
        n.expires_at=Math.floor(Date.now()/1000)+Number(n.expires_in||3600);
        store(n);notify('TOKEN_REFRESHED',n);return n;
      }catch(e){return s}
    }

    var auth={
      async getSession(){
        var s=await refreshIfNeeded();
        return {data:{session:s},error:null};
      },
      async signUp(opts){
        try{
          var redirect=location.origin+'/pages/encheres';
          var res=await fetch(base+'/auth/v1/signup?redirect_to='+encodeURIComponent(redirect),{
            method:'POST',
            headers:{apikey:key,'Content-Type':'application/json'},
            body:JSON.stringify({
              email:opts.email,
              password:opts.password,
              data:(opts.options&&opts.options.data)||{}
            })
          });
          var p=await parseResponse(res);
          if(p.error)return {data:{user:null,session:null},error:p.error};
          var body=p.data||{};
          var session=body.access_token?body:null;
          if(session){
            session.expires_at=Math.floor(Date.now()/1000)+Number(session.expires_in||3600);
            store(session);notify('SIGNED_IN',session);
          }
          return {data:{user:body.user||null,session:session},error:null};
        }catch(e){return {data:{user:null,session:null},error:{message:e.message||String(e)}}}
      },
      async signInWithPassword(opts){
        try{
          var res=await fetch(base+'/auth/v1/token?grant_type=password',{
            method:'POST',
            headers:{apikey:key,'Content-Type':'application/json'},
            body:JSON.stringify({email:opts.email,password:opts.password})
          });
          var p=await parseResponse(res);
          if(p.error)return {data:{user:null,session:null},error:p.error};
          var session=p.data||null;
          if(session){
            session.expires_at=Math.floor(Date.now()/1000)+Number(session.expires_in||3600);
            store(session);notify('SIGNED_IN',session);
          }
          return {data:{user:session&&session.user?session.user:null,session:session},error:null};
        }catch(e){return {data:{user:null,session:null},error:{message:e.message||String(e)}}}
      },
      async signOut(){
        var s=getStored();
        try{
          if(s&&s.access_token){
            await fetch(base+'/auth/v1/logout',{method:'POST',headers:{apikey:key,Authorization:'Bearer '+s.access_token}});
          }
        }catch(e){}
        store(null);notify('SIGNED_OUT',null);
        return {error:null};
      },
      onAuthStateChange(fn){
        listeners.push(fn);
        return {data:{subscription:{unsubscribe:function(){listeners=listeners.filter(function(x){return x!==fn})}}}};
      }
    };

    async function rpc(name,args){
      await refreshIfNeeded();
      try{
        var res=await fetch(base+'/rest/v1/rpc/'+encodeURIComponent(name),{
          method:'POST',
          headers:apiHeaders(true),
          body:JSON.stringify(args||{})
        });
        return await parseResponse(res);
      }catch(e){return {data:null,error:{message:e.message||String(e)}}}
    }

    function Query(table){
      this.table=table;this.columns='*';this.filters=[];this.orders=[];this.limitN=null;this.mode='many';
    }
    Query.prototype.select=function(cols){this.columns=cols||'*';return this};
    Query.prototype.eq=function(col,val){this.filters.push([col,'eq.'+String(val)]);return this};
    Query.prototype.in=function(col,vals){this.filters.push([col,'in.('+vals.map(String).join(',')+')']);return this};
    Query.prototype.order=function(col,opts){this.orders.push(col+'.'+(opts&&opts.ascending===false?'desc':'asc'));return this};
    Query.prototype.limit=function(n){this.limitN=n;return this};
    Query.prototype.maybeSingle=function(){this.mode='maybe';return this};
    Query.prototype.single=function(){this.mode='single';return this};
    Query.prototype.run=async function(){
      await refreshIfNeeded();
      try{
        var params=new URLSearchParams();params.set('select',this.columns);
        this.filters.forEach(function(f){params.append(f[0],f[1])});
        if(this.orders.length)params.set('order',this.orders.join(','));
        if(this.limitN!=null)params.set('limit',String(this.limitN));
        var res=await fetch(base+'/rest/v1/'+encodeURIComponent(this.table)+'?'+params.toString(),{headers:apiHeaders(false)});
        var p=await parseResponse(res);
        if(p.error)return p;
        var arr=Array.isArray(p.data)?p.data:[];
        if(this.mode==='maybe')return {data:arr.length?arr[0]:null,error:null};
        if(this.mode==='single'){
          if(arr.length!==1)return {data:null,error:{message:arr.length?'Plusieurs résultats reçus.':'Aucun résultat.'}};
          return {data:arr[0],error:null};
        }
        return {data:arr,error:null};
      }catch(e){return {data:null,error:{message:e.message||String(e)}}}
    };
    Query.prototype.then=function(resolve,reject){return this.run().then(resolve,reject)};

    return {
      auth:auth,
      rpc:rpc,
      from:function(table){return new Query(table)}
    };
  }

  window.supabase={createClient:createClient};
})();
